import { useIntl } from '@capsicum/common';
import { Button } from '@capsicum/common-web';

import { S } from './Password.styled';

export interface FormWithoutPasswordInputProps {
	isLoading?: boolean;
	onWithdraw: () => void;
}

export function FormWithoutPasswordInput({ isLoading, onWithdraw }: FormWithoutPasswordInputProps) {
	const { $t } = useIntl();

	const texts = {
		confirmButton: $t('wallet.withdraw.password.buttonConfirm')
	};

	return (
		<S.ButtonSectionNoPassword>
			<Button
				disabled={isLoading}
				fullWidth
				isLoading={isLoading}
				testID="withdraw-confirmation-submitButton"
				text={texts.confirmButton}
				onClick={() => {
					onWithdraw();
				}}
			/>
		</S.ButtonSectionNoPassword>
	);
}
